import * as React from "react";
import { Typography, Grid, CardContent, Card } from "@mui/material";
import { useMediaQuery, useTheme } from "@mui/material";
import "./lotterySystem.css";
import tvGif from '../common/gif/TV.gif';
import salesGif from '../common/gif/sales.gif';
import liveGif from '../common/gif/live.gif';
import displayGif from '../common/gif/display.gif';
import increaseGif from '../common/gif/increase.gif';
import autoSync from '../common/gif/autoSync.gif';
import { useTranslation } from 'react-i18next';

const MoreFeatures: React.FC = () => {
  const { t } = useTranslation('translation');
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md")); // Mobile & Tablet (below 1024px)

  return (
    <Grid container spacing={isMobileOrTablet ? 3 : 4} justifyContent="center">
      {[
        { img: tvGif, title: "customLotteryScreenTitle", desc: "customLotteryScreenDescription", imgSize: "40%" },
        { img: salesGif, title: "salesManagementTitle", desc: "salesManagementDescription", imgSize: "25%" },
        { img: increaseGif, title: "increaseSalesConversionTitle", desc: "increaseSalesConversionDescription", imgSize: "45%" },
        { img: autoSync, title: "autoSyncWithStateDataTitle", desc: "autoSyncWithStateDataDescription", imgSize: "30%" },
        { img: liveGif, title: "liveLottery99.9%UptimeTitle", desc: "liveLottery99.9%UptimeDescription", imgSize: "40%" },
        { img: displayGif, title: "mountedLotteryDisplayTitle", desc: "mountedLotteryDisplayDescription", imgSize: "40%" },
      ].map((feature, index) => (
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          lg={3}
          key={index}
          display="flex"
          justifyContent="center"
        >
          <Card className="landing-feature-grid-card">
            <img
              className="landing-feature-grid-card-gif"
              src={feature.img}
              alt="feature gif"
              style={{
                width: feature.imgSize,
                height: "auto",
                display: "block",
                margin: "auto",
                marginTop: "20px"
              }}
            />
            <CardContent>
              <Typography className="landing-secondary-color landing-grid-card-title" align="center">
                {t(feature.title)}
              </Typography>
              <Typography className="landing-grid-card-description landing-text-color" variant="body2" align="center">
                {t(feature.desc)}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default MoreFeatures;
